import { handleActions } from "redux-actions";
import { getRequestObject } from "../../utils/helpers";
import { ACTIONS } from "./actions";
import { SingInModal } from "./types";

const initialState: SignInState = {
	requestCode: getRequestObject(),
	validateCode: getRequestObject(),
	checkIsSignedIn: getRequestObject(),
	openModal: null,
};

export default handleActions(
	{
		[`${ACTIONS.REQUEST_CODE_ACTION}_PENDING`]: (state) => ({
			...state,
			requestCode: {
				...state.requestCode,
				loading: true,
			},
		}),
		[`${ACTIONS.REQUEST_CODE_ACTION}_REJECTED`]: (state, action) => ({
			...state,
			requestCode: {
				error: action.payload,
				success: null,
				loading: false,
			},
		}),
		[`${ACTIONS.REQUEST_CODE_ACTION}_FULFILLED`]: (state, action) => ({
			...state,
			requestCode: {
				success: action.payload,
				error: null,
				loading: false,
			},
		}),
		[`${ACTIONS.VALIDATE_CODE_ACTION}_PENDING`]: (state) => ({
			...state,
			validateCode: {
				...state.validateCode,
				loading: true,
			},
		}),
		[`${ACTIONS.VALIDATE_CODE_ACTION}_REJECTED`]: (state, action) => ({
			...state,
			validateCode: {
				error: action.payload,
				success: null,
				loading: false,
			},
		}),
		[`${ACTIONS.VALIDATE_CODE_ACTION}_FULFILLED`]: (state, action) => ({
			...state,
			validateCode: {
				success: action.payload,
				error: null,
				loading: false,
			},
		}),
		[`${ACTIONS.CHECK_IS_SIGNED_IN}_PENDING`]: (state) => ({
			...state,
			checkIsSignedIn: {
				...state.checkIsSignedIn,
				loading: true,
			},
		}),
		[`${ACTIONS.CHECK_IS_SIGNED_IN}_REJECTED`]: (state, action) => ({
			...state,
			checkIsSignedIn: {
				error: action.payload,
				success: null,
				loading: false,
			},
			validateCode: {
				...state.validateCode,
				error: action.payload,
			},
		}),
		[`${ACTIONS.CHECK_IS_SIGNED_IN}_FULFILLED`]: (state, action) => ({
			...state,
			checkIsSignedIn: {
				success: action.payload,
				error: null,
				loading: false,
			},
		}),
		[`${ACTIONS.CHECK_IS_CODE_REQUESTED}_PENDING`]: (state) => ({
			...state,
			requestCode: {
				...state.requestCode,
				loading: true,
			},
		}),
		[`${ACTIONS.CHECK_IS_CODE_REQUESTED}_REJECTED`]: (state, action) => ({
			...state,
			requestCode: {
				error: action.payload,
				success: null,
				loading: false,
			},
		}),
		[`${ACTIONS.CHECK_IS_CODE_REQUESTED}_FULFILLED`]: (state, action) => ({
			...state,
			requestCode: {
				success: action.payload,
				error: null,
				loading: false,
			},
		}),
		[ACTIONS.SET_OPEN_MODAL]: (state, action) => ({
			...state,
			openModal: action.payload as any,
		}),
		[ACTIONS.RESET_SIGN_IN_CHECK_DATA]: (state, action) => ({
			...state,
			checkIsSignedIn: getRequestObject(),
		}),
	},
	initialState
);

export interface SignInState {
	requestCode: any;
	validateCode: any;
	checkIsSignedIn: any;
	openModal: SingInModal | null;
}
